<script>
  import { createEventDispatcher, getContext, onDestroy } from "svelte";
  import EncodingHex from "./EncodingHex.svelte";
  import PunchCardInfo from "./PunchCardInfo.svelte";
  import { encodingToHex } from "bitframes";
  import Button from "./Button.svelte";
  import downloadIcon from "../icons/download2.svelte";
  import shareIcon from "../icons/share2.svelte";
  import History from "./History.svelte";
  import * as local from "../util/local.js";
  import TweakPane from "./TweakPane.svelte";

  const dispatch = createEventDispatcher();
  const encodingStore = getContext("encoding");

  export let isMobile = false;
  export let innerScroll = false;
  // let showHistoryToolbar = false;

  export let edition = false;

  let encoding;
  const unsub = encodingStore.subscribe((v) => {
    encoding = v;
  });

  onDestroy(() => {
    unsub();
  });

  let curMode = local.get("edit-mode", "edit");
  $: local.set("edit-mode", curMode);

  let showShareText = false;

  let modes = ["edit", "data", "history"];

  let historyExpanded = true;

  function save() {}
  function share() {}
</script>

<div class="container" class:innerScroll>
  <div class="nav-container">
    <div class="nav-buttons">
      {#each modes as mode (mode)}
        <button
          class="tab noselect"
          on:click={(ev) => {
            ev.preventDefault();
            curMode = mode;
          }}
          class:active={curMode == mode}>{mode.toUpperCase()}</button
        >
      {/each}
    </div>
    {#if curMode == "history" && isMobile}
      <!-- <div class="expand-history">
        <Button
          on:click={(ev) => {
            historyExpanded = true;
          }}
          square
          icon={plusIcon}
          small
          fitHeight
        ></Button>
      </div> -->
    {/if}
  </div>
  <div class="content">
    {#if curMode == "data"}
      <div class="data-container">
        <div class="share-buttons">
          <Button
            fitHeight
            small
            icon={downloadIcon}
            text={"Download"}
            on:click={(ev) => {
              ev.preventDefault();
              dispatch("save");
            }}
          ></Button>
          <Button
            small
            fitHeight
            icon={shareIcon}
            text={"Share"}
            on:click={(ev) => {
              ev.preventDefault();
              dispatch("share");
            }}
          ></Button>
        </div>
        <div class="punched-card-container">
          <PunchCardInfo clickable={false} marginTop={false}></PunchCardInfo>
          <div class="encoding-hex">
            <EncodingHex
              small
              encodingHex={encodingToHex(encoding)}
              maxWidth="100%"
            />
          </div>
        </div>

        <!-- <HexPairEditor on:encodingChanged {encoding}></HexPairEditor> -->
      </div>
    {:else if curMode == "edit"}
      <div class="tweak-container">
        <TweakPane {edition} {encoding} on:encodingChanged />
      </div>
    {:else if curMode == "history"}
      <div class="history-container" class:expanded={historyExpanded}>
        <History
          {encoding}
          showToolbar={!isMobile}
          on:change={(e) => {
            encoding = e.detail;
            dispatch("encodingChanged", encoding);
          }}
        />
      </div>
    {/if}
  </div>
</div>

<style>
  .container {
    /* border-left: 2px solid black; */
    width: 100%;
    padding: 0px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
  }
  .innerScroll.container {
    height: 100%;
    overflow: hidden;
  }
  .content {
    /* padding: 20px; */
    /* overflow: auto; */
    border-top: 1px solid black;
  }
  .innerScroll .content {
    height: 100%;
    overflow: hidden;
  }
  .history-container {
    overflow: hidden;
    height: 100%;
  }
  .history-container.expanded {
    /* background: pink;
    position: fixed;
    top: calc(20px + 46px);
    left: 20px;
    width: calc(100vw - 40px); */
    /* height: calc(100vh - 46px); */
  }
  .tweak-container {
    height: 100%;
    overflow-y: auto;
    box-sizing: border-box;
  }
  .data-container {
    padding: 20px;
    height: 100%;
    overflow-y: auto;
    box-sizing: border-box;
    /* overflow: hidden; */
  }
  .punched-card-container {
    /* width: 100%; */
    /* width: calc(min(500px, 100%)); */
    /* max-height: 50%; */
    /* padding: 10px; */
    /* height: 100px; */
    max-width: 650px;
    box-sizing: border-box;
    display: flex;
    /* overflow-y: scroll; */
    flex-grow: 1;
    flex-shrink: 1;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
  }
  .encoding-hex {
    /* padding-left: 10px; */
    /* padding-right: 10px; */
    /* padding-bottom: 5px; */
    max-width: 100%;
    margin-top: 5px;
    box-sizing: border-box;
    align-self: flex-start;
    /* width: 100%; */
    display: flex;
    flex-shrink: 1;
    user-select: text;
    pointer-events: auto;
  }
  .expand-history {
    height: 100%;
    box-sizing: border-box;
    padding: 10px;
  }
  .nav-container,
  .nav-buttons,
  .share-buttons {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 0px;
    box-sizing: border-box;
  }
  .nav-container {
    justify-content: space-between;
    flex-grow: 0;
    height: 40px;
  }
  .nav-container .tab {
    --highlight-color: white;
    --default-color: hsl(0, 0%, 90%);

    background-color: var(--default-color);
    appearance: none;
    height: 100%;
    border-radius: 0;
    /* background-color: white; */
    margin: 0;
    cursor: pointer;
    padding: 10px;
    border-right: 1px solid black;
    /* border-top: 1px solid black; */
    /* border-bottom: 1px solid black; */
  }
  .nav-buttons {
    height: 100%;
  }
  .share-buttons {
    margin-bottom: 20px;
    display: flex;
    /* width: 100%; */
    padding: 0px;
    /* margin-top: 20px; */
    flex-grow: 0;
    flex-shrink: 1;
    box-sizing: border-box;
    /* justify-content: flex-end; */
    /* justify-content: space-between; */
    /* align-items: flex-start; */
    gap: 10px;
    /* margin-top: 20px; */
  }
  .tab:last-child {
    /* border-right: 4px solid black; */
  }
  .nav-container .tab.active {
    background-color: var(--highlight-color);
    position: relative;
    cursor: default;
  }
  .nav-container .tab.active::after {
    content: " ";
    width: 100%;
    position: absolute;
    bottom: -1px;
    z-index: 10;
    left: 0;
    height: 4px;
    background: var(--highlight-color);
    /* border-bottom: 1px dotted rgba(0, 0, 0, 0.5); */
  }
</style>
